<template>
	<div id="draggable">
		<!-- 如果碰到滑动问题，1.1 请检查这里是否属于同一点。 -->
		<!-- 悬浮的HTML -->
		<div class="parentWeightCard" ref="moveDiv" @mousedown="down" @touchstart="down" @mousemove="move"
		     @touchmove.prevent="move" @mouseup="end" @touchend="end" :style="showWeight?{width:'270px'}:{width:'100px'}">
			<div class="weightCardLeft" v-if="showWeight">
				<div style="font-size: 26px;font-weight: bold;color: #F0F0F0;margin: 16px;text-align: center;" v-if="isOnline">
					{{weightNumber}}{{weightUnit}}
				</div>
				<div v-else style="font-size: 26px;font-weight: bold;color: #F0F0F0;margin: 16px;text-align: center;">正在重连...</div>
			</div>
			<!--<Poptip title="Title" content="content">-->
			<div class="weightCardRight" id="weightCardRight" @click="handleClick" v-drag>
				<div style="height: 40px;text-align: center;line-height: 40px;font-size: 22px;font-weight: bold;">
					{{weighingFrame}}
				</div>
				<div style="height: 30px;text-align: center;font-size: 16px;">称重框({{$store.state.boxSetting.showCount}}个)</div>
			</div>
			<!--</Poptip>-->
			<Modal v-model="showModal" footer-hide :width="750" @on-visible-change="saveBoxSetting">
				<div slot="header"><b>称重框设置</b></div>
				<Form label-position="left">
					<FormItem v-for="(item,index) of $store.state.boxSetting.selectBoxList" :key="index">
						<div slot="label">称重框:</div>
						<Select @on-change="changeBoxs($event,index)" style="width: 260px;" size="large" placeholder="称重框" v-model="item.id" transfer>
							<Option v-for="(item, index) in $store.state.allTurnoverBoxs" :value="item.id" :key="index" :label="item.title">
								<span>{{ item.title }}</span>
							</Option>
						</Select>
						&nbsp;&nbsp;
						<span>数量:</span>
						<InputNumber controls-outside size="large" :min="1" v-model="item.count"/>
						<a style="padding-left: 10px;color: #e13d13" @click="deleteTurnoverBox(index)">删除</a>
						<div style="color: #c5c8ce" v-if="$store.state.boxSetting.selectBoxList.length">
							电子秤读数将自动扣除称重框重量，请先放置称重框然后设置去皮
						</div>
					</FormItem>

					<FormItem>
						<div slot="label">称重借出周转物:</div>
						<i-switch size="large" v-model="$store.state.boxSetting.autoLent" :true-value="true" :false-value="false">
							<span slot="open">开</span>
							<span slot="close">关</span>
						</i-switch>
					</FormItem>
				</Form>
				<Button size="large" long icon="md-add" @click="addTurnoverBox">添加称重框</Button>
			</Modal>
		</div>
	</div>
</template>

<script>
	import {changeUnit} from "@/libs/util";
	import {saveBoxSetting} from "@/api/sorting/turnoverBox"

	export default {
		name: "weightReading",
		props: {
			// 是否显示实时重量
			showWeight: {
				type: Boolean,
				default: true
			},
			// 最大限制
			unit: {
				type: String,
				default: "斤"
			},
		},
		data() {
			return {
				changeUnit,
				flags: false,
				position: {x: 0, y: 0}, // 鼠标的横纵坐标
				pageX: "", // 页面可视区域的宽
				pagey: "", // 页面可视区域的高
				nx: "",
				ny: "",
				dx: "",
				dy: "",
				xPum: "",
				yPum: "",
				// 当前读数
				weightNumber: 0,
        //当前读数单位
        weightUnit: "",
        //称重筐重量
        weighingFrame: "",
				// 设置称重框弹窗
				showModal: false,
				// 连接是否在线
				isOnline: true,
				// 周转物列表
				// turnoverList: [],
				// 展示周转物配置信息
				// showWeight: 0,
				// showCount: 0,
				// 定时检测电子秤是否有读数
				timer: null,
			};
		},
		directives: {
			drag(el) {
				const oDiv = el;
				// 拖拽时间标识
				let firstTime = "";
				let lastTime = "";
				document.onselectstart = function () {
					return false
				};
				oDiv.onmousedown = function (e) {
					// 为了区分点击还是拖拽，使用时间差来判断，200毫秒内为点击，200毫秒外为拖拽，初始化为点击
					document.getElementById('weightCardRight').setAttribute('drag-flag', false);
					firstTime = new Date().getTime();

					// oDiv.offsetParent.offsetWidth - oDiv.offsetLeft - oDiv.offsetWidth
					// 表示元素距离父元素右边距的距离
					const disX = oDiv.offsetParent.offsetWidth - oDiv.offsetLeft - oDiv.offsetWidth + e.clientX;
					// oDiv.offsetTop 表示距离父元素顶边距的距离
					const disY = oDiv.offsetTop - e.clientY;
					// 设置最大右边距
					const maxRight = oDiv.offsetParent.offsetWidth - oDiv.offsetWidth;
					// 设置最大顶边距
					const maxTop = oDiv.offsetParent.offsetHeight - oDiv.offsetHeight;
					document.onmousemove = function (e) {
						// 计算当前右边距并设置
						const r = Math.min(maxRight, Math.max(disX - e.clientX, 0));
						oDiv.style.right = r + 'px';
						// 计算当前顶边距并设置
						const t = Math.min(maxTop, Math.max(disY + e.clientY, 0));
						oDiv.style.top = t + 'px';

						// 判断下当前时间与初始时间差，大于100毫秒则判断状态为拖拽
						lastTime = new Date().getTime();
						if (lastTime - firstTime > 100) {
							document.getElementById('weightCardRight').setAttribute('drag-flag', true);
						}
					};
					// 鼠标抬起时清除事件
					document.onmouseup = function (e) {
						document.onmousemove = null;
						document.onmouseup = null;
					};
					return false;
				}
			}
		},
		methods: {
      //切换称重框
      changeBoxs(data, index) {
        if(data) {
          this.$store.state.boxSetting.selectBoxList[index].id = data
        }
      },
      // 称重筐重量单位转换
      showUnitValue() {
        let unitValue = localStorage.getItem('unitValue') ? localStorage.getItem('unitValue') : 1
        if(unitValue == 1 ){
          this.weightUnit = "斤"
          let weight = changeUnit(this.$store.state.boxSetting.showWeight,"g",'斤') + '斤'
          this.weighingFrame = weight
        }
        if(unitValue == 2 ){
          this.weightUnit = "kg"
          let weight = changeUnit(this.$store.state.boxSetting.showWeight,"g",'kg') + 'kg'
          this.weighingFrame = weight
        }
      },
			// 打开电子秤监听
			openWeightDevice() {
				let that = this;
				setTimeout(async () => {
					window.removeEventListener("weightCall", this.listenWeightCall);
					window.addEventListener("weightCall", this.listenWeightCall);
					if (!that.$store.state.hasChromeApp) {
						let result = await that.$store.dispatch("initChromeApp");
						if (result !== true) {
							that.$Notice.destroy();
							that.$Notice.error({title: "电子秤连接失败", duration: 0});
						}
					}
				}, 1000);
			},
			listenWeightCall(event) {
				if (event.type == "weightCall") {
					// console.log(event.detail);
					this.closeTimer();
					// 转换单位
					if (event.detail && event.detail.weight) {
						let weight = event.detail.weight;
            // console.log("称重框重量", this.$store.state.boxSetting.showWeight)

						if (this.$store.state.boxSetting && this.$store.state.boxSetting.showWeight) {
							// 减去称重框重量
							weight -= this.$store.state.boxSetting.showWeight;
						}
						if (weight < 0) {
							weight = 0;
						}
            // console.log("去皮后重量", weight)
            let unitValue = localStorage.getItem('unitValue') ? localStorage.getItem('unitValue') : 1
            // console.log("计重单位", unitValue)
						this.weightNumber = changeUnit(weight, "g", (unitValue == 1?'斤':'kg'));
					} else {
						this.weightNumber = 0;
					}
					this.submitWeightData();
				}
			},
			// 返回数据
			submitWeightData() {
				this.$emit('reciveData', {data: this.weightNumber});
			},
			// 打开定时器
			openTimer() {
				this.timer = setInterval(async () => {
					// 连接不在线
					this.isOnline = false;
					this.openWeightDevice();
					this.$store.state.hasChromeApp = false;
					// console.log("连接不在线")
				}, 1500);
			},
			// 关闭定时器
			closeTimer() {
				// 连接在线
				this.isOnline = true;
				if (this.timer) {
					clearInterval(this.timer);
					// console.log("关闭定时器");
					this.openTimer();
				} else {
					this.openTimer();
				}
			},
			// 点击事件
			handleClick() {
				// 点击事件触发时，判断当前状态是拖拽还是点击，若是拖拽，直接返回不继续执行
				const isDrag = document.getElementById('weightCardRight').getAttribute('drag-flag');
				if (isDrag === 'true') {
					return
				}
				this.showModal = true;
				this.$store.dispatch("queryTurnoverBoxList");
			},
			// 实现移动端拖拽
			down() {
				this.flags = true; //是否开启拖拽
				let touch;
				if (event.touches) {
					touch = event.touches[0];
				} else {
					touch = event;
				}
				this.position.x = touch.clientX;
				this.position.y = touch.clientY;
				this.dx = this.$refs.moveDiv.offsetLeft;
				this.dy = this.$refs.moveDiv.offsetTop;
			},
			move() {
				if (this.flags) {
					let touch;
					if (event.touches) {
						touch = event.touches[0];
					} else {
						touch = event;
					}
					this.nx = touch.clientX - this.position.x;
					this.ny = touch.clientY - this.position.y;

					this.yPum = this.dy + this.ny;
					if (this.dx + this.nx <= 0) {
						this.xPum = 0;
					} else if (this.dx + this.nx >= this.pageX - 270) {
						this.xPum = this.pageX - 270;
					} else {
						this.xPum = this.dx + this.nx;
					}
					if (this.dy + this.ny <= 0) {
						this.yPum = 0;
					} else if (this.dy + this.ny >= this.pagey - 80) {
						this.yPum = this.pagey - 80;
					} else {
						this.yPum = this.dy + this.ny;
					}
					this.$refs.moveDiv.style.left = this.xPum + "px";
					this.$refs.moveDiv.style.top = this.yPum + "px";
					//阻止页面的滑动默认事件；如果碰到滑动问题，1.2 请注意是否获取到 touchmove
					document.addEventListener("touchmove",
						function () {
							event.preventDefault();
						},
						false
					);
				}
			},
			//鼠标释放时候的函数
			end() {
				this.flags = false;
			},
			// 查询周转物
			/*queryTurnoverBoxList() {
				return new Promise((resolve, reject) => {
					let param = {rows: 100, box_type: 2};
					queryTurnoverBoxList(param).then(data => {
						if (data.status === 200) {
							this.$store.state.allTurnoverBoxs = data.data.data.rows;
						}
					});
				}).catch(err => {
					console.log(err);
					this.$Message.error(err);
				});
			},*/
			// 添加周转物
			addTurnoverBox() {
				this.$store.state.boxSetting.selectBoxList.push({id: 0, count: 1});
			},
			// 删除周转物
			deleteTurnoverBox(index) {
				this.$store.state.boxSetting.selectBoxList.splice(index, 1);
			},
			// 保存称重框设置
			saveBoxSetting(event) {
				if (event) {
					return;
				}
				// 判断有没有重复数据
				let data = {};
				for (let i = 0; i < this.$store.state.boxSetting.selectBoxList.length; i++) {
					if (!this.$store.state.boxSetting.selectBoxList[i].id)
						continue;
					if (data[this.$store.state.boxSetting.selectBoxList[i].id]) {
						data[this.$store.state.boxSetting.selectBoxList[i].id].count += this.$store.state.boxSetting.selectBoxList[i].count;
					} else {
						data[this.$store.state.boxSetting.selectBoxList[i].id] = this.$store.state.boxSetting.selectBoxList[i];
					}
				}
				let keys = Object.keys(data);
        this.$store.state.boxSetting.showWeight = 0
				let selectBoxList = [];
				for (let i = 0; i < keys.length; i++) {
					for (let j = 0; j < this.$store.state.allTurnoverBoxs.length; j++) {
						if (this.$store.state.allTurnoverBoxs[j].id == keys[i]) {
							data[keys[i]].title = this.$store.state.allTurnoverBoxs[j].title
							data[keys[i]].weight = parseFloat((this.$store.state.allTurnoverBoxs[j].box_weight * data[keys[i]].count).toFixed(3));
						}
					}
          this.$store.state.boxSetting.showWeight += data[keys[i]].weight
					selectBoxList.push(data[keys[i]]);
				}
				this.$store.state.boxSetting.selectBoxList = selectBoxList;
        this.showUnitValue()
				// localStorage.setItem("boxSetting", JSON.stringify(this.$store.state.boxSetting));
				saveBoxSetting(this.$store.state.boxSetting).then(res => {
					if (res.status === 200) {
						this.$store.dispatch("getDeliverySetting");
					}
				});
			},
		},
		mounted() {
			this.pageX = document.body.offsetWidth;
			this.pagey = document.body.offsetHeight;
			this.openWeightDevice();
      this.showUnitValue()
		},
		destroyed() {
			window.removeEventListener("weightCall", this.listenWeightCall);
		},
	}
</script>

<style scoped>
	.parentWeightCard {
		/* 如果页面报错 [Intervention] Unable to preventDefault inside passive event listener due to target being treated as passive. See <URL>；   请添加样式 touch-action: none; */
		touch-action: none;
		height: 70px;
		/*width: 270px;*/
		/* 如果碰到滑动问题，1.3 请检查 z-index。z-index需比web大一级*/
		z-index: 999;
		position: fixed;
		top: 0px;
		left: 48%;
		right: 0;
		display: flex;
		cursor: pointer;
	}

	.weightCardLeft {
		/* 如果页面报错 [Intervention] Unable to preventDefault inside passive event listener due to target being treated as passive. See <URL>；   请添加样式 touch-action: none; */
		height: 70px;
		width: 170px;
		border-radius: 2px 0px 2px 2px;
		background-color: rgba(0, 0, 0, 0.75);
	}

	.weightCardRight {
		/* 如果页面报错 [Intervention] Unable to preventDefault inside passive event listener due to target being treated as passive. See <URL>；   请添加样式 touch-action: none; */
		height: 70px;
		width: 100px;
		border: #dedede 1px solid;
		background-color: #fff;
	}
</style>



// WEBPACK FOOTER //
// src/components/weightReading/weightReading.vue